import Response from 'modules/reports/orm/Response'
import {useState} from 'react'
import useUrlParams from 'modules/reports/hooks/urlParams'

export type SearchState<TModel = any, TParams = any, TFilters = any, TDisplay = any> = {
  request: Promise<Response<TModel[]>> | undefined
  response: Response<TModel[]> | undefined
  data: TModel[]
  total: number
  query: string
  params: TParams | any
  filters: TFilters | any
  display: TDisplay | any
  sort: string
  offset: {start: number; end: number}
}

export function useSearchState<TModel, TParams, TFilters, TDisplay>(
  defaultState: Partial<SearchState<TModel, TParams, TFilters, TDisplay>>
): [
  SearchState<TModel, TParams, TFilters, TDisplay>,
  (state: SearchState<TModel, TParams, TFilters, TDisplay>) => void
] {
  const urlParams = useUrlParams('q', 'start', 'end')
  const [state, setState] = useState<SearchState<TModel, TParams, TFilters, TDisplay>>({
    data: [],
    total: 0,
    request: undefined,
    response: undefined,
    query: (urlParams.q || defaultState.query || '') as string,
    params: defaultState.params || {},
    filters: defaultState.filters || {},
    display: defaultState.display || {},
    sort: urlParams.sort || defaultState.sort,
    offset: {start: urlParams.start, end: urlParams.end},
  })

  return [state, setState]
}
